import { render, staticRenderFns } from "./navTab.vue?vue&type=template&id=1c7d28b2&scoped=true&"
import script from "./navTab.vue?vue&type=script&lang=js&"
export * from "./navTab.vue?vue&type=script&lang=js&"
import style0 from "./navTab.vue?vue&type=style&index=0&id=1c7d28b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7d28b2",
  null
  
)

export default component.exports